import { render } from "./ModalContainer.vue?vue&type=template&id=321b7518&ts=true"
import script from "./ModalContainer.vue?vue&type=script&lang=ts"
export * from "./ModalContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__